import styles from './HostServiceDetail.module.css'
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { HostServiceDetailInformation } from './HostServiceDetailInformation'
import { HostServiceDetailPrices } from './HostServiceDetailPrices'
import type { HostServiceDetailPricesProps } from './HostServiceDetailPrices'
import { useNavigate } from 'react-router-dom';
import { ApplicationMainToolbarContent } from 'shared/widgets/ApplicationMainToolbarContent';
import { useDynamicMainToolbar } from 'shared/hooks/useMainToolbar';
import { HostServiceDetailAvailability } from './HostServiceDetailAvailability';
import { HostServiceDetailPhotos } from './HostServiceDetailPhotos';
import { HostServiceDetailHeading } from './HostServiceDetailHeading';

export interface HostServiceDetailProps {
    hostServiceId: number;
    monitorIdforPrices?: number;
};

export const HostServiceDetail = (props: HostServiceDetailProps): JSX.Element => {
    const {
        hostServiceId, 
        monitorIdforPrices
    } = props;

    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }

    const mainToolbarContent = (
        <ApplicationMainToolbarContent
            title={`Details`}
            back={{
                callback:handleBack,
                checkHasBackPage: true
            }}
        />
    )
    
    useDynamicMainToolbar(mainToolbarContent, [])

    const hostServiceDetailGeneralInformationProps: any = {
        hostServiceId: hostServiceId,
    }

    const hostServiceDetailPricesProps: HostServiceDetailPricesProps = {
        hostServiceId: hostServiceId
    }

    if (monitorIdforPrices !== undefined) {
        hostServiceDetailPricesProps.monitorId = monitorIdforPrices;
        hostServiceDetailGeneralInformationProps.monitorId = monitorIdforPrices;
    }
           
    return (
            <div className={styles.HostServiceDetail}>   
                <div>
                    <div 
                        className={styles.HostServiceDetail__HeadingContainer}>
                        <HostServiceDetailHeading 
                            hostServiceId={hostServiceId} 
                            spyId={monitorIdforPrices} 
                        />
                    </div> 
                    <div 
                        className={styles.HostServiceDetail__HostServiceDetailPhotosContainer}>
                        <HostServiceDetailPhotos 
                            hostServiceId={hostServiceId} 
                            spyId={monitorIdforPrices} 
                        />
                    </div>
                    <div className={styles.HostServiceDetail__HostServiceDetailGeneralInformationContainer}>
                        <HostServiceDetailInformation
                            hostServiceId={hostServiceId}
                            monitorId={monitorIdforPrices}
                        />
                    </div>
                </div>
                <div>
                    <div className={styles.HostServiceDetail__HostServiceDetailPricesContainer}>
                        <HostServiceDetailPrices
                            {...hostServiceDetailPricesProps}                   
                        />
                    </div>
                    <div className={styles.HostServiceDetail__HostServiceDetailAvailabilityContainer}>
                        <HostServiceDetailAvailability
                            hostServiceId={hostServiceId}
                            spyId={monitorIdforPrices}
                        />
                    </div> 
                </div>
            </div>
    )
}